export default __webpack_public_path__ + "static/media/hygienic.b5386079.png";